import classes from "../../Styles/common.module.css";

const PageHeader = (props) => {
  return (
    <>
      <h1 className={classes.title}>{props.children}</h1>
    </>
  );
};

export default PageHeader;
